export const SCHEDULED_PUBLISHING_TOOL_NAME = 'schedules'
